// extracted by mini-css-extract-plugin
export default {"productGallery":"HJ-z","inQuickShop":"IJ-z"};